import { render, staticRenderFns } from "./addMasterStockCode.vue?vue&type=template&id=bb5f28a6&"
import script from "./addMasterStockCode.vue?vue&type=script&lang=js&"
export * from "./addMasterStockCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports